module.exports = __webpack_public_path__ + "static/media/the-castle.82072925.jpg";